import { FC, PropsWithChildren } from 'react'

import { useAtomValue } from 'jotai'
import { useLocation } from 'react-router-dom'

import SearchInfo from '@/components/SearchInfo'
import Icon from '@/components/Icon'
import { useUnclaimedRewardsAtom, loginStateAtom, store } from '@/store'
import { cn, customJumpHref, handletaskPageEntryTrack, jumpMainLogin } from '@/utils'

const HomeNav = [
  {
    name: 'Story',
    key: '/home',
  },
  {
    name: 'Discover',
    key: '/home/discover',
  },
]

const HomeLayout: FC<PropsWithChildren> = (props) => {
  const { children } = props

  const channelSearch = sessionStorage.getItem('channelSearch') || ''
  const location = useLocation()
  const { pathname } = useLocation()
  const isLogin = useAtomValue(loginStateAtom)
  const { unclaimedRewards } = useUnclaimedRewardsAtom()

  const handleNavChange = (nav: string) => {
    customJumpHref(nav)
  }

  const handleToRewardsPage = () => {
    if (!store.get(loginStateAtom)) {
      return jumpMainLogin()
    }
    sessionStorage.setItem('customerBackUrl', location.pathname)
    handletaskPageEntryTrack(3)
    customJumpHref('/rewards')
  }

  return (
    <>
      <div
        className={cn(
          'fixed left-0 right-0 top-0 z-10 flex h-[101px] items-center justify-between bg-global-top-color',
          'shadow-[0px_4px_19px_0px_var(--global-top-shadow-color)]',
        )}
        id='homeLayoutHeader'
      >
        <div
          className={cn(
            'flex items-center',
            '[&_span]:relative [&_span]:mr-[52px] [&_span]:font-geologica [&_span]:text-[34px] [&_span]:text-color-white-trans60',
          )}
        >
          <div
            className={cn('ml-[24px] mr-[37px] h-[50px] w-[50px] cursor-pointer')}
            onClick={() => {
              customJumpHref(`/home${channelSearch}`)
            }}
            id='logo'
          >
            <Icon className='h-full w-full' name='Logo' />
          </div>

          {HomeNav.map((item) => {
            return (
              <span
                key={item.key}
                className={cn(
                  'cursor-pointer',
                  pathname === item.key
                    ? "!text-base-text-color after:absolute after:bottom-[-28px] after:left-0 after:right-0 after:mx-auto after:h-[6px] after:w-[37px] after:rounded-[4px] after:bg-base-text-color after:content-['']"
                    : '',
                  pathname === item.key ? 'guide-storyNav' : 'guide-discoverNav',
                )}
                onClick={() => {
                  handleNavChange(item.key)
                  window.scrollTo(0, 0)
                }}
              >
                {item.name}
              </span>
            )
          })}
        </div>

        <div className={cn('mr-[30px] flex items-center justify-center')}>
          <div
            className={cn('relative mr-[45px] h-[52px] w-[52px] cursor-pointer rounded-full', !isLogin && 'h-[67px] w-[75px]')}
            onClick={handleToRewardsPage}
          >
            {!isLogin ? null : unclaimedRewards.no_received_task ? (
              <span
                className={cn('absolute right-0 top-0 block h-[15px] w-[15px] rounded-full', 'border-[4px] border-solid border-base-color bg-[red]')}
              ></span>
            ) : null}
            <Icon className='h-full w-full' name={isLogin ? 'GiftIcon' : 'GiftRegister'} />
          </div>
          <SearchInfo />
        </div>
      </div>
      {children}
    </>
  )
}

export default HomeLayout
